import { Box } from '@jfs/ui-new'
import { useEffect, useState } from 'react'
import * as React from 'react'
import { DefaultDropDown } from './DefaultDropDown'
import { DropDownBox } from './DropDownBox'
import { dropdownPlacementTopValue } from './DropdownConstants'
import { renderPortal } from './DropdownPotal'
import { styles } from './styles'
import { DropDownProps, DropdownTypes, itemSelected } from './types'

const TestId = 'dropdown'
const zIndex = 999999 //This high value because modal too has some zindex due to which it gets hidden when opent in modal.
const customRange = 'Custom Range'

const ContentDropdown: React.FC<DropDownProps> = ({
  placeHolder,
  onChange,
  data,
  type = DropdownTypes.DEFAULT_WITH_IMAGE,
  hide = false,
  fieldName,
  setFieldValue,
  label,
}: DropDownProps) => {
  const [dropdownVisible, toggleDropdown] = useState(false)
  const [defaultLabel, updateLabel] = useState('')
  const [layoutValue, onLayout] = useState({ left: 0, top: 0, width: 0 }) as any

  useEffect(() => {
    setFieldValue && setFieldValue(fieldName ?? '', defaultLabel)
  }, [defaultLabel, fieldName, setFieldValue])

  const onDropdownItemPress = (item: itemSelected) => {
    const selectedValue = item?.value ?? ''
    if (selectedValue === customRange) {
      updateLabel('')
    } else {
      updateLabel(item?.value)
    }
    toggleDropdown(!dropdownVisible)
    onChange(selectedValue)
  }

  const renderDropDown = (): any => {
    return data && dropdownVisible ? (
      <Box {...styles.modal} zIndex={zIndex} onPress={() => [toggleDropdown(false)]}>
        <Box
          {...styles.dropdownContainer}
          width={layoutValue?.width}
          left={layoutValue?.left}
          top={layoutValue?.top + dropdownPlacementTopValue}>
          <DefaultDropDown data={data} onDropdownItemPress={onDropdownItemPress} selectedValue={defaultLabel} />
        </Box>
      </Box>
    ) : null
  }

  if (hide) {
    return null
  } else {
    return (
      <Box testID={TestId}>
        <DropDownBox
          onLayout={onLayout}
          toggleDropdown={toggleDropdown}
          defaultLabel={label}
          dropdownVisible={dropdownVisible}
          type={type}
          value={defaultLabel}
          label={label}
          placeholder={placeHolder}
        />
        {renderPortal(renderDropDown)}
      </Box>
    )
  }
}

export { ContentDropdown }
